// extracted by mini-css-extract-plugin
module.exports = {"root":"MenuItem_root__1sHNQ","root__selected":"MenuItem_root__selected__3D7V0"};